import "../../style.css";
import React, { useState, useMemo, useContext } from 'react';
import axios from 'axios';
import { GlobalContext } from '../../context/GlobalContext';
import EditableField from "../../components/EditableField";
import { BsArrowDownUp } from "react-icons/bs";
import DetailModal from "../../components/Common/DetailModal";

const LocatMergeTranslationUpdate = ({ currentPosts, handleCheckboxChange, setFilterData, setData, filterData, selectedIds, selectAll, handleSelectAll, selectedDomain, locateId }) => {
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const { API_URL, showToast } = useContext(GlobalContext);
  const [idDetails, setIdDetails] = useState([]);
  const [showIdModal, setShowIdModal] = useState(false);
  const [idLoading, setIdLoading] = useState(false);

  const handleEdit = async (id, field, value) => {
    const updatedData = filterData.map((item) => {
      if (item.id === id) {
        return {
          ...item,
          [field]: value,
        };
      }
      return item;
    });
    setData(updatedData);
    setFilterData(updatedData);

    // Make the API call to update the database
    try {
      const response = await axios.post(`${API_URL}/updateSegemntPart/${id}`, { [field]: value, domain: selectedDomain });

      if (response.status === 200) {
        showToast('success', response.data.message, 'top', 10);
      } else {
        showToast('error', 'Failed to update data', 'top', 10);
        throw new Error('Failed to update data');
      }
    } catch (error) {
      console.error('Error updating data:', error);

      setData(filterData);
      setFilterData(filterData);
    }
  };


  const handleSort = (column) => {
    if (column === sortColumn) {
      setSortDirection((prevSortDirection) =>
        prevSortDirection === "asc" ? "desc" : "asc"
      );
    } else {
      setSortColumn(column);
      setSortDirection("asc");
    }
  };

  const sortedData = useMemo(() => {
    const sortedArray = [...currentPosts];

    if (sortColumn !== "") {
      sortedArray.sort((a, b) => {
        const valueA = a[sortColumn];
        const valueB = b[sortColumn];

        if (sortColumn === "lastmodified") {
          // Convert timestamps to Date objects for comparison
          const dateA = new Date(valueA).getTime();
          const dateB = new Date(valueB).getTime();

          if (dateA < dateB) return sortDirection === "asc" ? -1 : 1;
          if (dateA > dateB) return sortDirection === "asc" ? 1 : -1;
          return 0;
        } else {
          if (valueA < valueB) return sortDirection === "asc" ? -1 : 1;
          if (valueA > valueB) return sortDirection === "asc" ? 1 : -1;
          return 0;
        }
      });
    }

    return sortedArray;
  }, [currentPosts, sortColumn, sortDirection]);

  // Fetch ID details
  const openIdDetails = async (row) => {
    setShowIdModal(true);
    setIdLoading(true);
    try {
      setIdDetails(row || []);
    } catch (err) {
      setIdDetails([]);
    } finally {
      setIdLoading(false);
    }
  };



  return (
    <>
      <div className="container-fluid mb-2 mt-2">
        <table id="" className="table table-bordered" style={{ color: "#222" }}>
          <thead className="">
            <tr>
              <th className="width-2p text-center" scope="row">
                <input
                  id={`${locateId}-checkall`}
                  type="checkbox"
                  checked={currentPosts.length > 0 && currentPosts.every(item => selectedIds.includes(item.id))}
                  onChange={handleSelectAll} />
              </th>
              {/* <th onClick={() => handleSort("id")} className="width-3p text-center" scope="col">
                S.No. <b><BsArrowDownUp /></b>
              </th> */}
              <th onClick={() => handleSort("id")} className="width-3p" scope="col">
                id{" "} <b> <BsArrowDownUp /></b>
              </th>
              <th onClick={() => handleSort("refid")} className="width-4p" scope="col">
                ref. ID{" "} <b> <BsArrowDownUp /></b>
              </th>
              {/* <th className="width-9p" scope="col">
                Source text
              </th> */}
              <th className="width-9p" scope="col">
                Clean text
              </th>
              <th className="width-8p text-center" scope="col">
                Clean MD5
              </th>
              {/* <th className="width-7p text-center" scope="col">
                Parent MD5
              </th> */}
              {/* <th className="width-3p text-center" scope="col">
                Parent ID
              </th> */}
              <th onClick={() => handleSort("seq")} className="width-3p text-center" scope="col">
                seq <b><BsArrowDownUp /></b>
              </th>

              <th
                onClick={() => handleSort("part")}
                className="width-3p text-center"
                scope="col"
              >
                part{" "}<b><BsArrowDownUp /></b>
              </th>
              <th
                onClick={() => handleSort("multipart")}
                className="width-4p text-center"
                scope="col"
              >
                Multipart{" "}<b><BsArrowDownUp /></b>
              </th>
            </tr>
          </thead>
          <tbody>
            {sortedData.map((myData, index) => (
              <tr key={myData.id} style={{ backgroundColor: selectedIds.includes(myData.id) ? '#c1d3f0' : '' }}>
                <td className="">
                  <div className="custom-control custom-checkbox text-center">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      id={`${locateId}-customCheck${myData.id}`}
                      checked={selectedIds.includes(myData.id) || selectAll}
                      onChange={() => handleCheckboxChange(myData.id)}
                    />
                  </div>
                </td>
                {/* <td className="text-center width-4p" style={{ 'whiteSpace': 'pre-wrap', wordWrap: "break-word", overflow: "hidden" }}>
               {index + 1}
              </td> */}
                <td className="">{myData.id}</td>
                <td className="">{myData.refid}</td>
                {/* <td className="wrap-text">
                  <div> {myData.srctxt} </div>
                </td> */}
                <td className="">
                  <div> {myData.cleantxt} </div>
                </td>

                <td className="wrap-text" >
                  <strong
                    id={`${locateId}-openModel`}
                    className="text-primary"
                    style={{ cursor: 'pointer' }}
                    onClick={() => openIdDetails(myData)}
                  >
                    {myData.cleanmd5}
                  </strong>
                </td>
                {/* <td><div className="wrap-text">{myData.psrcmd5 || "Not Found"}</div></td>
                <td className="wrap-text">
                  {myData.pcid}
                </td> */}
                <td className="wrap-text">
                  {myData.seq}
                </td>
                <td>
                  <EditableField
                    value={myData.part}
                    onChange={(value) => handleEdit(myData.id, "part", value)}
                  />
                </td>
                <td>
                  <EditableField
                    value={myData.multipart}
                    onChange={(value) => handleEdit(myData.id, "multipart", value)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <DetailModal
        show={showIdModal}
        title={`ID Details: ${selectedIds}`}
        data={idDetails}
        loading={idLoading}
        onClose={() => setShowIdModal(false)}
      />
    </>
  );
};

export default LocatMergeTranslationUpdate;
